var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSheetAnnotationsGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.964 56.8406L69.0679 124.233L136.45 130.128L142.347 62.7358L74.964 56.8406Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00004 30.47C9.00381 28.5141 9.51746 26.5929 10.4903 24.8961C11.4631 23.1993 12.8615 21.7855 14.5476 20.794C16.2336 19.8026 18.1489 19.2679 20.1047 19.2426C22.0604 19.2174 23.989 19.7024 25.7 20.65V90.13C23.9853 89.1804 22.0521 88.6953 20.0922 88.7228C18.1322 88.7503 16.2135 89.2894 14.526 90.2867C12.8386 91.284 11.441 92.705 10.4717 94.4087C9.50241 96.1124 8.99511 98.0398 9.00004 100V30.47Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.27 114.66C117.27 115.59 118.11 116.28 119.33 116.39C120.55 116.5 121.33 115.95 121.44 115.11C121.55 114.27 121.04 113.9 119.92 113.51L118.85 113.13C117.32 112.59 116.68 111.84 116.78 110.68C116.9 109.26 118.23 108.37 120.01 108.53C120.369 108.522 120.726 108.586 121.06 108.717C121.393 108.849 121.698 109.045 121.955 109.296C122.212 109.546 122.416 109.845 122.556 110.176C122.696 110.506 122.769 110.861 122.77 111.22L121.7 111.13C121.7 110.21 121 109.58 119.89 109.48C118.78 109.38 117.96 109.89 117.89 110.73C117.83 111.37 118.27 111.8 119.41 112.2L120.28 112.51C122.01 113.11 122.66 113.85 122.55 115.08C122.42 116.64 121.1 117.51 119.14 117.33C117.18 117.15 116.14 116.08 116.2 114.57L117.27 114.66Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.17,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.87 122.96C125.487 122.96 130.04 118.407 130.04 112.79C130.04 107.173 125.487 102.62 119.87 102.62C114.253 102.62 109.7 107.173 109.7 112.79C109.7 118.407 114.253 122.96 119.87 122.96Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5599 88.1199C82.0448 88.08 81.5426 87.9384 81.0825 87.7033C80.6224 87.4682 80.2134 87.1442 79.8793 86.7501C79.5452 86.356 79.2924 85.8995 79.1358 85.4072C78.9791 84.9148 78.9215 84.3963 78.9665 83.8815C79.0114 83.3668 79.1579 82.866 79.3975 82.4082C79.6372 81.9505 79.9651 81.5447 80.3625 81.2145C80.7599 80.8842 81.2188 80.636 81.7127 80.4842C82.2066 80.3323 82.7256 80.2799 83.2399 80.3299",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4401 78C82.4434 77.862 81.5379 77.3461 80.9111 76.559C80.2843 75.7719 79.9842 74.7739 80.0729 73.7716C80.1615 72.7693 80.6322 71.8395 81.3874 71.1747C82.1427 70.5099 83.1246 70.1609 84.13 70.2",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113 72.72C114.033 72.8115 114.987 73.3096 115.653 74.1047C116.319 74.8999 116.642 75.927 116.55 76.96C116.459 77.993 115.96 78.9474 115.165 79.6131C114.37 80.2789 113.343 80.6015 112.31 80.51",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.09 82.8499C112.602 82.8945 113.101 83.0396 113.557 83.2768C114.013 83.5141 114.418 83.8388 114.748 84.2326C115.079 84.6263 115.329 85.0813 115.483 85.5715C115.638 86.0618 115.695 86.5777 115.65 87.0899C115.606 87.602 115.46 88.1004 115.223 88.5564C114.986 89.0125 114.661 89.4174 114.267 89.748C113.874 90.0786 113.419 90.3284 112.928 90.4831C112.438 90.6378 111.922 90.6945 111.41 90.6499",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1299 70.1901C84.1698 69.6749 84.3113 69.1727 84.5465 68.7126C84.7816 68.2525 85.1056 67.8436 85.4997 67.5094C85.8938 67.1753 86.3502 66.9226 86.8426 66.7659C87.335 66.6092 87.8535 66.5517 88.3682 66.5966C88.883 66.6415 89.3837 66.788 89.8415 67.0277C90.2993 67.2673 90.705 67.5953 91.0353 67.9926C91.3655 68.39 91.6138 68.8489 91.7656 69.3428C91.9174 69.8367 91.9699 70.3558 91.9199 70.8701",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2603 71.0799C94.3504 70.0456 94.8478 69.0894 95.643 68.4218C96.4381 67.7542 97.4659 67.4298 98.5003 67.5199C99.5346 67.6101 100.491 68.1075 101.158 68.9026C101.826 69.6978 102.15 70.7256 102.06 71.7599",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.4 71.9999C104.538 71.0032 105.054 70.0977 105.841 69.471C106.628 68.8442 107.626 68.544 108.628 68.6327C109.631 68.7214 110.56 69.192 111.225 69.9472C111.89 70.7025 112.239 71.6845 112.2 72.6899",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M110.63 90.5799C110.54 91.6142 110.043 92.5704 109.248 93.238C108.452 93.9057 107.425 94.2301 106.39 94.1399C105.356 94.0497 104.4 93.5524 103.732 92.7572C103.064 91.962 102.74 90.9342 102.83 89.8999",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.49 89.69C100.4 90.7244 99.9025 91.6805 99.1074 92.3481C98.3122 93.0158 97.2844 93.3402 96.2501 93.25C95.2157 93.1598 94.2596 92.6625 93.592 91.8673C92.9243 91.0722 92.5999 90.0444 92.6901 89.01",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3601 88.8099C90.2221 89.8065 89.7062 90.712 88.9191 91.3388C88.132 91.9656 87.134 92.2657 86.1317 92.177C85.1294 92.0884 84.1997 91.6177 83.5348 90.8625C82.87 90.1073 82.521 89.1253 82.5601 88.1199",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4001 94.74H40.3301V46.54H54.5301",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0601 46.54H105.09V52.76",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2998 51V44.45",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4502 68.4299H54.9702",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0001 109.35H20.5001C17.7312 109.35 15.0757 108.25 13.1179 106.292C11.16 104.334 10.0601 101.679 10.0601 98.9099",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6802 31.9299H119.7V54.4999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M129.42 98.3199L132.76 60.1299",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7202 84.27L128.39 89.32",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M126.59 130.7L127.8 116.89",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheetAnnotationsGrey);
export default __webpack_public_path__ + "static/media/sheet_annotations_grey.3b5250b98316c327d72b3c5933254f09.svg";
export { ForwardRef as ReactComponent };